"use client"

import { useEffect, useState } from "react"

/**
 * useAutoIndex
 * 0 ile (length - 1) arasında döngüsel (wrap-around) bir index değeri üretir.
 * Belirlediğiniz gecikme süresinde (delay) index otomatik olarak artar.
 *
 * @param {number} length - Toplam öğe sayısı. 0 veya falsy ise zamanlayıcı başlatılmaz.
 * @param {number} [delay=5000] - Artış aralığı (ms). Varsayılan 5000 ms.
 * @returns {[number, Function]} Aktif index ve manuel güncelleme için setIndex fonksiyonu.
 *
 * Örnek kullanım:
 * const [current, setCurrent] = useAutoIndex(images.length, 3000)
 * <img src={images[current]} />
 */
export default function useAutoIndex(length, delay = 5000) {
  // Şu anki aktif öğenin indeksini tutar
  const [index, setIndex] = useState(0)

  useEffect(() => {
    // length geçerli değilse interval kurmaya gerek yok
    if (!length) return

    // Her delay ms'de bir index'i bir artır, sona gelince başa sar
    const id = setInterval(() => setIndex((i) => (i + 1) % length), delay)

    // Bileşen unmount olduğunda veya length/delay değiştiğinde interval temizlenir
    return () => clearInterval(id)
  }, [length, delay])

  // Dışarıya hem kontrol değerini hem de manuel set fonksiyonunu döner
  return [index, setIndex]
}
